
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

import { ChangePasswordDto } from '@models/users/login.dto';

import {
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

@Component({
  selector: 'ebs-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.scss'],
})
export class ChangePasswordDialogComponent {
  formGroup!: FormGroup;

  changePassword: ChangePasswordDto = {
    newPassword: '',
    oldPassword: '',
  };

  get errors(): string {
    if (this.formGroup.invalid) {
      if (this.formGroup.controls['oldPassword'].errors !== null) {
        if (this.formGroup.controls['oldPassword'].errors['required']) {
          return 'Password vecchia obbligatoria';
        } else if (
          this.formGroup.controls['oldPassword'].errors['minlength']
        ) {
          return 'Lunghezza minima 8 caratteri';
        } else if (
          this.formGroup.controls['oldPassword'].errors['pattern']
        ) {
          return 'Almeno un carattere speciale, una maiuscola, una minuscola e un numero';
        }
      } else if (
        this.formGroup.controls['newPassword'].errors !== null
      ) {
        if (this.formGroup.controls['newPassword'].errors['required']) {
          return 'Password nuova obbligatoria';
        } else if (
          this.formGroup.controls['newPassword'].errors['minlength']
        ) {
          return 'Lunghezza minima 8 caratteri';
        } else if (
          this.formGroup.controls['newPassword'].errors['pattern']
        ) {
          return 'Almeno un carattere speciale, una maiuscola, una minuscola e un numero';
        }
      } else if (
        this.formGroup.controls['confirmPassword'].errors !== null
      ) {
        if (
          this.formGroup.controls['confirmPassword'].errors['required']
        ) {
          return 'Conferma obbligatoria';
        } else if (
          this.formGroup.controls['confirmPassword'].errors['minlength']
        ) {
          return 'Lunghezza minima 8 caratteri';
        } else if (
          this.formGroup.controls['confirmPassword'].errors['pattern']
        ) {
          return 'Almeno un carattere speciale, una maiuscola, una minuscola e un numero';
        }
      } else if (this.formGroup.errors !== null) {
        if (this.formGroup.errors['PasswordNoMatch']) {
          return 'Conferma la password nuova';
        } else if (
          this.formGroup.errors['EqualsToOld']
        ) {
          return 'Uguale a quella vecchia';
        }
      }
    }

    return '';
  }

  confirmPassword: string = '';

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    // Titolo predefinito della dialog,
    // indipendente dalla pagina che la apre.
    this.config.header = 'Cambio Password';

    this.formGroup = new FormGroup(
      {
        oldPassword: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[?%&!@#$%^&*_=().:,;£+|\\\/\-]).{8,32}$/,
            ),
          ]),
        ),

        newPassword: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[?%&!@#$%^&*_=().:,;£+|\\\/\-]).{8,32}$/,
            ),
          ]),
        ),

        confirmPassword: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[?%&!@#$%^&*_=().:,;£+|\\\/\-]).{8,32}$/,
            ),
          ]),
        ),
      },
      [
        this.confirmPasswordValidator,
        this.differentFromOldPasswordValidator,
      ],
    );
  }

  close() {
    this.ref.close(this.changePassword);
  }

  confirmPasswordValidator: ValidatorFn = (
    control: AbstractControl,
  ): ValidationErrors | null => {
    return control.value.newPassword ===
      control.value.confirmPassword
      ? null
      : { PasswordNoMatch: true };
  };

  differentFromOldPasswordValidator: ValidatorFn = (
    control: AbstractControl,
  ): ValidationErrors | null => {
    return control.value.newPassword !==
      control.value.oldPassword
      ? null
      : { EqualsToOld: true };
  };
}
